// Every date/time the admin site prints is Indian Standard Time, whatever the browser's timezone is.
// Date.toLocale*String() reads the device timezone unless one is passed, so default it to IST here;
// a call that passes its own timeZone still wins.
const IST = 'Asia/Kolkata';

['toLocaleString', 'toLocaleDateString', 'toLocaleTimeString'].forEach((name) => {
  const original = Date.prototype[name];
  if (original.__istDefault) return;
  const withIst = function (locales, options) {
    return original.call(this, locales, { timeZone: IST, ...(options || {}) });
  };
  withIst.__istDefault = true;
  Date.prototype[name] = withIst;
});
